import { motion, Variants } from "framer-motion";
import styled from "styled-components";
import { ArtifactTheme } from "../../models/client";
import { Fade } from "../animations/fade";
import { Box } from "../Box";
import { Container } from "../Container";
import { FlexContainer, FlexItem } from "../Flex";
import { Text } from "../Text";
import ATOtherItem from "./ATOtherItem";

interface PTOtherProps {
  artifactTheme: ArtifactTheme;
}

const Wrapper = styled.div`
  padding: 90px 0;
  background-color: white;
  min-height: 600px;
`;

const otherVariants: Variants = {
  initial: { opacity: 0, y: 20 },
  inView: { opacity: 1, y: 0 },
};

export const PTOther: React.FC<PTOtherProps> = ({ artifactTheme }) => {
  if (artifactTheme.otherObjects.length > 0) return (
    <Wrapper>
      <Container maxWidth={[4]}>
        <Box mb={[4, 5]}>
          <Fade direction="l">
            <Text variant="h2">Other objects of interest</Text>
          </Fade>
        </Box>

        <motion.div
          whileInView="inView"
          initial="initial"
          transition={{ staggerChildren: 0.2, delayChildren: 0.4 }}
        >
          <FlexContainer flexWrap="wrap" justifyContent="space-between">
            {artifactTheme.otherObjects.map((object) => (
              <FlexItem key={object.id} flex={["0 0 100%", null, "0 0 28%"]}>
                <motion.div variants={otherVariants}>
                  <ATOtherItem object={object} />
                </motion.div>
              </FlexItem>
            ))}
          </FlexContainer>
        </motion.div>
      </Container>
    </Wrapper>
  );
  return null;
};
